<script setup lang="ts">
import { xmIconNames, type XmIconName } from '@/common/types/icon-names';
import { IconType } from '@/types/icon.types';
import { computed } from 'vue';
import type { Size } from '@/types/common.types';
import { ICON_SIZE_MAP } from '@/common/define/icon.define';

interface Props {
  name: XmIconName | IconType;
  size?: Size | number;
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: () => 'medium' as const,
  color: 'currentColor',
});

const iconSize = computed(() =>
  typeof props.size === 'string' ? ICON_SIZE_MAP[props.size] : props.size,
);
const isXmIcon = (name: unknown): name is XmIconName => {
  return xmIconNames.includes(name as XmIconName);
};

const iconNameClass = computed(() => {
  if (isXmIcon(props.name)) {
    return `xm-icon--${props.name}`;
  }
  return props.name;
});
</script>

<template>
  <i
    :class="['xm-icon', iconNameClass]"
    :style="{
      '--xm-icon-size': `${iconSize}px`,
      '--xm-icon-color': props.color,
    }"
    role="img"
    :aria-label="props.name"
  />
</template>
